export const dateType = ["year", "month", "date", "hours", "minute", "second"];
export const classNames = {
  active: "picker-selection active",
  default: "picker-selection",
};
